import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const ActionsRoot = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.neutrals.beige2,
    margin: 0,
    alignItems: 'center',
    padding: ` ${theme.spacing(2)} ${theme.spacing(3)}`
  }
}));
